import type { TableHeaderSpec } from '@/@vxapp/@Types/ServiceMetadata'

export const OrdersTableHeaders = [
  {
    title: '#ID',
    align: 'start',
    key: 'id',
    placeholder: '00000',
  },
  {
    title: 'Status',
    align: 'start',
    key: 'status',
    sortable: false,
    placeholder: null,
  },
  {
    title: 'Product',
    align: 'start',
    key: 'productGUID',
    sortable: false,
    placeholder: 'Product Name',
  },
  {
    title: 'Contact',
    align: 'start',
    key: 'contactData',
    sortable: false,
    placeholder: '######## ##########',
  },
  {
    title: 'Total',
    align: 'start',
    key: 'SERVICE_BILLING_GROSS',
    sortable: false,
    placeholder: '0.00',
  },
  {
    title: 'Date Created',
    align: 'start',
    key: 'SERVICE_DATE',
    sortable: false,
    placeholder: '00/00/0000',
  },
  {
    title: 'Address',
    align: 'start',
    key: 'address',
    sortable: false,
    placeholder: 'City, State',
  },
  {
    title: 'Actions',
    align: 'end',
    key: 'actions',
    sortable: false,
  },
] as const satisfies readonly TableHeaderSpec[]
